import { render, staticRenderFns } from "./JobSampleSettingsSidebar.vue?vue&type=template&id=64d8d50e&scoped=true"
import script from "./JobSampleSettingsSidebar.vue?vue&type=script&lang=js"
export * from "./JobSampleSettingsSidebar.vue?vue&type=script&lang=js"
import style0 from "./JobSampleSettingsSidebar.vue?vue&type=style&index=0&id=64d8d50e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d8d50e",
  null
  
)

export default component.exports